import React, { useState, useEffect } from 'react';
import { FaPaintBrush, FaArrowLeft, FaCheckCircle, FaCloudDownloadAlt, FaTh, FaSync } from 'react-icons/fa';

// 🔥 IMPORTAMOS LOS LOGOS DESDE LA CARPETA ASSETS
import hoppytimeLogo from './assets/mi-logo.png';
import kokimikoLogo from './assets/kokimiko-logo.png'; 

const CentroDeDisenoView = () => {
    
    // Estados principales
    const [sitioActivo, setSitioActivo] = useState(null);
    const [conectando, setConectando] = useState(false);
    const [extrayendo, setExtrayendo] = useState(false);
    const [codigoCanva, setCodigoCanva] = useState(null);
    const [tokenListo, setTokenListo] = useState(false);
    const [disenos, setDisenos] = useState([]); 
    const [disenoSeleccionado, setDisenoSeleccionado] = useState(null);
    const [sincronizando, setSincronizando] = useState(false);

    // Llaves Maestras de la Integración
    const CANVA_CLIENT_ID = 'OC-AZ7wdvfW0agc'; 
    const CANVA_CLIENT_SECRET = 'cnvca2vGOAK7Hu6azT9sd526Vcf_mnSNuT2ob-q-TwD_b-0U9169e17e'; 
    
    // 🔥 SOLUCIÓN DEFINITIVA: Forzamos la barra final "/" para evitar choques de normalización
    const REDIRECT_URI = window.location.origin + "/"; 

    // 🕸️ LA TRAMPA: Interceptamos el éxito o el rebote de Canva
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');

        // Verificar si ya tenemos token guardado
        if (localStorage.getItem('canva_access_token')) {
            setTokenListo(true);
        }

        if (error) {
            console.error("Error de Canva:", error);
            alert("Canva rechazó la conexión. Revisa la consola.");
            window.history.replaceState({}, document.title, window.location.pathname);
            return;
        }

        if (code) {
            console.log("¡Código de Canva atrapado por Jarvis!", code);
            setCodigoCanva(code);
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, []);

    const volverAlHub = () => {
        setSitioActivo(null);
        setConectando(false);
        setDisenos([]); // Limpiamos diseños al volver
        setDisenoSeleccionado(null);
    };

    // 🔥 MOTOR DE SINCRONIZACIÓN: Trae los cambios hechos en el popup a tu App
    const sincronizarDiseno = async () => {
        setSincronizando(true);
        try {
            const accessToken = localStorage.getItem('canva_access_token');
            const response = await fetch(`https://api.canva.com/rest/v1/designs/${disenoSeleccionado.id}`, {
                method: 'GET',
                headers: { 'Authorization': `Bearer ${accessToken}` }
            });
            const data = await response.json();
            console.log("Datos maestros sincronizados:", data);
            alert("¡Sincronización exitosa! Los cambios están en la matriz.");
        } catch (error) {
            alert("Error al sincronizar: " + error.message);
        } finally {
            setSincronizando(false);
        }
    };

    // 🔥 NUEVO MOTOR POPUP: Lanza Canva en una ventana controlada para saltar la seguridad
    const handleSeleccionarDiseno = (diseno) => {
        setDisenoSeleccionado(diseno);
        console.log("Abriendo editor en ventana flotante para:", diseno.title);
        
        const editUrl = (diseno.urls && diseno.urls.edit_url) 
            ? diseno.urls.edit_url 
            : `https://www.canva.com/design/${diseno.id}/edit`;

        const width = 1100;
        const height = 800;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;

        window.open(
            editUrl,
            'CanvaEditorModal',
            `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`
        );
    };

    const iniciarConexionCanva = async () => {
        setConectando(true);
        
        try {
            localStorage.removeItem('canva_access_token');
            setTokenListo(false);

            const array = new Uint8Array(32);
            window.crypto.getRandomValues(array);
            const codeVerifier = btoa(String.fromCharCode(...array))
                .replace(/\+/g, '-')
                .replace(/\//g, '_')
                .replace(/=+$/, '');
            
            localStorage.setItem('canva_code_verifier', codeVerifier);

            const encoder = new TextEncoder();
            const data = encoder.encode(codeVerifier);
            const digest = await window.crypto.subtle.digest('SHA-256', data);
            const codeChallenge = btoa(String.fromCharCode(...new Uint8Array(digest)))
                .replace(/\+/g, '-')
                .replace(/\//g, '_')
                .replace(/=+$/, '');

            const scope = 'design:meta:read profile:read design:content:read';
            const authUrl = `https://www.canva.com/api/oauth/authorize?client_id=${CANVA_CLIENT_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&response_type=code&scope=${encodeURIComponent(scope)}&code_challenge=${codeChallenge}&code_challenge_method=s256`;
            
            console.log("Viajando a Canva con llaves encriptadas...", authUrl);
            window.location.href = authUrl;
        } catch (error) {
            console.error("Jarvis Error: Fallo en el motor criptográfico PKCE", error);
            alert("Hubo un error generando las llaves de seguridad en el navegador. Intenta de nuevo.");
            setConectando(false);
        }
    };

    // 🚀 NUEVO MOTOR: Canje del Token Maestro con Detector de Errores
    const extraerDisenosDeCanva = async () => {
        setExtrayendo(true);
        try {
            let accessToken = localStorage.getItem('canva_access_token');

            if (!accessToken) {
                const codeVerifier = localStorage.getItem('canva_code_verifier');
                
                if (!codeVerifier || !codigoCanva) {
                    alert("Faltan credenciales. Por favor, vuelve a vincular tu cuenta de Canva.");
                    setExtrayendo(false);
                    return;
                }

                console.log("Jarvis: Iniciando canje del Ticket por el Token de Acceso Maestro...");

                const credencialesEncriptadas = btoa(`${CANVA_CLIENT_ID}:${CANVA_CLIENT_SECRET}`);

                const body = new URLSearchParams({
                    grant_type: 'authorization_code',
                    code_verifier: codeVerifier,
                    code: codigoCanva,
                    redirect_uri: REDIRECT_URI
                });

                const response = await fetch('https://api.canva.com/rest/v1/oauth/token', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': `Basic ${credencialesEncriptadas}`
                    },
                    body: body.toString()
                });

                const data = await response.json();

                if (!response.ok) {
                    console.error("Jarvis Error: Falla en el canje del token:", data);
                    alert("Canva rechazó el canje del ticket: " + (data.error_description || data.error));
                    setExtrayendo(false);
                    return;
                }

                accessToken = data.access_token;
                localStorage.setItem('canva_access_token', accessToken);
                setTokenListo(true);
                console.log("¡BINGO! Token Maestro de Canva obtenido.");
            }

            const response = await fetch('https://api.canva.com/rest/v1/designs', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 401) {
                console.warn("Token revocado. Limpiando memoria...");
                localStorage.removeItem('canva_access_token');
                setTokenListo(false);
                setCodigoCanva(null);
                throw new Error("El token de acceso expiró o fue revocado. Por favor, vuelve a vincular tu cuenta.");
            }

            const data = await response.json();
            if (!response.ok) throw new Error("Error al listar diseños: " + data.message);

            console.log("¡DISEÑOS RECIBIDOS EN LA MATRIZ!", data);
            setDisenos(data.items || []); 
            alert("¡Diseños extraídos con éxito! Revisa la consola para ver tu lista de proyectos.");
            
        } catch (error) {
            console.error("Jarvis Error:", error);
            alert("Error: " + error.message);
        } finally {
            setExtrayendo(false);
        }
    };

    if (sitioActivo) {
        return (
            <div className="fixed inset-0 z-50 flex flex-col bg-gray-900 font-sans">
                
                <div className="bg-[#2C3E50] text-white p-3 flex justify-between items-center shadow-md z-10 border-b border-gray-700">
                    <div className="flex items-center gap-4">
                        <button 
                            onClick={volverAlHub}
                            className="flex items-center gap-2 px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg transition duration-200 text-sm font-semibold"
                        >
                            <FaArrowLeft /> Volver al Hub
                        </button>
                        <div className="h-6 w-px bg-gray-600 mx-2"></div>
                        <h2 className="text-lg font-bold flex items-center gap-2">
                            <FaPaintBrush className="text-[#18BC9C]" />
                            Gestor de Diseños Canva: <span className="text-[#18BC9C] tracking-wide">{sitioActivo}</span>
                        </h2>
                    </div>
                </div>

                <div className="flex-1 overflow-y-auto bg-[#f8f9fa] p-10">
                    <div className="max-w-6xl mx-auto">
                        
                        {disenoSeleccionado ? (
                            <div className="bg-white p-10 rounded-2xl shadow-xl border-t-8 border-[#18BC9C] mb-8 text-center flex flex-col items-center justify-center min-h-[400px]">
                                <div className="w-24 h-24 bg-[#e8f5e9] rounded-full flex items-center justify-center mb-6 shadow-inner">
                                    <FaPaintBrush className="text-[#18BC9C] text-4xl animate-bounce" />
                                </div>
                                <h3 className="text-3xl font-bold text-gray-800 mb-2">Editando: {disenoSeleccionado.title}</h3>
                                <p className="text-gray-500 max-w-lg mx-auto mb-8 text-lg">
                                    El editor de Canva se ha abierto en una ventana segura flotante. 
                                    <br /><br />
                                    <span className="font-semibold text-gray-700">Cuando termines de diseñar, cierra esa ventana y vuelve aquí.</span>
                                </p>
                                
                                <div className="flex gap-4">
                                    <button 
                                        onClick={() => handleSeleccionarDiseno(disenoSeleccionado)} 
                                        className="bg-[#00C4CC] text-white px-8 py-3 rounded-xl font-bold hover:bg-[#009da1] transition-all shadow-md hover:-translate-y-1"
                                    >
                                        Reabrir Ventana Flotante
                                    </button>
                                    <button 
                                        onClick={sincronizarDiseno} 
                                        disabled={sincronizando}
                                        className="bg-[#18BC9C] text-white px-8 py-3 rounded-xl font-bold hover:bg-teal-500 transition-all shadow-md hover:-translate-y-1 flex items-center gap-2"
                                    >
                                        <FaSync className={sincronizando ? "animate-spin" : ""} /> {sincronizando ? "Sincronizando..." : "Sincronizar Cambios"}
                                    </button>
                                    <button 
                                        onClick={() => setDisenoSeleccionado(null)} 
                                        className="bg-gray-800 text-white px-8 py-3 rounded-xl font-bold hover:bg-black transition-all shadow-md hover:-translate-y-1"
                                    >
                                        Volver a la Galería
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="bg-white p-10 rounded-2xl shadow-xl border border-gray-100 relative w-full mb-8">
                                <div className="absolute top-6 right-6 flex items-center gap-2 text-xs font-bold px-4 py-2 bg-[#e8f5e9] text-[#2e7d32] rounded-full shadow-sm border border-[#c8e6c9]">
                                    <FaCheckCircle /> API Hoppytime CMS {tokenListo ? "Activa" : "Lista"}
                                </div>

                                <div className="flex items-center justify-center gap-6 mb-8 mt-4">
                                    <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-md border-2 border-gray-100 p-2 overflow-hidden">
                                        <img src={sitioActivo === 'Hoppytime' ? hoppytimeLogo : kokimikoLogo} alt="Sitio Logo" className="w-full h-full object-contain" />
                                    </div>
                                    <div className={`flex gap-2 ${codigoCanva || tokenListo ? 'text-[#18BC9C]' : 'text-gray-300'}`}>
                                        <span className="w-3 h-3 rounded-full bg-current animate-pulse"></span>
                                        <span className="w-3 h-3 rounded-full bg-current animate-pulse delay-75"></span>
                                        <span className="w-3 h-3 rounded-full bg-current animate-pulse delay-150"></span>
                                    </div>
                                    <div className="w-24 h-24 bg-[#00C4CC] rounded-full flex items-center justify-center text-white text-5xl font-bold shadow-md border-2 border-[#009da1]">
                                        C
                                    </div>
                                </div>

                                <h3 className="text-3xl font-bold text-gray-800 mb-4 text-center">
                                    {tokenListo ? "¡Sistema Conectado y Listo!" : (codigoCanva ? "¡Cuenta Vinculada con Éxito!" : "Sincroniza tu Documento Maestro")}
                                </h3>
                                
                                <div className="flex justify-center">
                                    {!tokenListo && !codigoCanva ? (
                                        <button 
                                            onClick={iniciarConexionCanva}
                                            disabled={conectando}
                                            className={`flex items-center justify-center gap-3 w-full max-w-md py-4 px-6 rounded-xl text-white font-bold text-lg shadow-lg transition-all duration-300 ${conectando ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#00C4CC] hover:bg-[#009da1] hover:shadow-xl hover:-translate-y-1'}`}
                                        >
                                            {conectando ? "Redirigiendo..." : "Vincular mi cuenta de Canva"}
                                        </button>
                                    ) : (
                                        <button 
                                            onClick={extraerDisenosDeCanva}
                                            disabled={extrayendo}
                                            className={`flex items-center justify-center gap-3 w-full max-w-md py-4 px-6 rounded-xl text-white font-bold text-lg shadow-lg transition-all duration-300 ${extrayendo ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#18BC9C] hover:bg-teal-500 hover:shadow-xl hover:-translate-y-1'}`}
                                        >
                                            {extrayendo ? "Extrayendo Diseños..." : "Extraer Diseños de Canva"}
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}

                        {!disenoSeleccionado && disenos.length > 0 && (
                            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
                                {disenos.map((diseno) => (
                                    <div key={diseno.id} className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 hover:shadow-xl transition-all">
                                        <div className="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                            {diseno.thumbnail && diseno.thumbnail.url ? (
                                                <img src={diseno.thumbnail.url} alt={diseno.title} className="w-full h-full object-cover" />
                                            ) : (
                                                <div className="text-center p-4">
                                                    <FaTh className="text-gray-300 text-3xl mx-auto" />
                                                    <p className="text-xs text-gray-400 mt-2">Sin vista previa</p>
                                                </div>
                                            )}
                                        </div>
                                        <div className="p-4">
                                            <h4 className="font-bold text-gray-800 truncate">{diseno.title || "Sin título"}</h4>
                                            <button 
                                                onClick={() => handleSeleccionarDiseno(diseno)}
                                                className="mt-4 w-full py-2 rounded-lg text-sm font-bold bg-gray-800 text-white hover:bg-black transition-colors"
                                            >
                                                Editar Diseño
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="p-6 bg-gray-50 min-h-full">
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-gray-800">Centro de Integración Canva</h1>
                <p className="text-gray-600 mt-2">Selecciona el ecosistema a editar. Enlazaremos directamente con tus documentos maestros de Canva.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl">
                <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden border border-gray-200 flex flex-col group cursor-pointer" onClick={() => setSitioActivo('Hoppytime')}>
                    <div className="h-40 bg-white flex items-center justify-center relative overflow-hidden border-b border-gray-100 p-4">
                        <img src={hoppytimeLogo} alt="Logo Hoppytime" className="h-full w-auto object-contain z-10 group-hover:scale-110 transition-transform duration-500" />
                        <div className="absolute inset-0 bg-gradient-to-t from-gray-50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    </div>
                    <div className="p-6 flex flex-col flex-1">
                        <h2 className="text-2xl font-bold text-gray-800 mb-2">Website Hoppytime</h2>
                        <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-xs font-bold rounded-full w-max mb-4 border border-blue-200">Landing B2B</span>
                        <p className="text-gray-600 mb-6 flex-1 text-sm">Accede al puente de conexión para actualizar la web comercial desde tu documento maestro de Canva.</p>
                    </div>
                </div>

                <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden border border-gray-200 flex flex-col group cursor-pointer" onClick={() => setSitioActivo('KOKIMIKO')}>
                    <div className="h-40 bg-white flex items-center justify-center relative overflow-hidden border-b border-gray-100 p-4">
                        <img src={kokimikoLogo} alt="Logo KOKIMIKO" className="h-full w-auto object-contain z-10 group-hover:scale-110 transition-transform duration-500" />
                        <div className="absolute inset-0 bg-gradient-to-t from-gray-50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    </div>
                    <div className="p-6 flex flex-col flex-1">
                        <h2 className="text-2xl font-bold text-gray-800 mb-2">Website KOKIMIKO</h2>
                        <span className="inline-block px-3 py-1 bg-orange-100 text-orange-800 text-xs font-bold rounded-full w-max mb-4 border border-orange-200">Espacio Intergeneracional</span>
                        <p className="text-gray-600 mb-6 flex-1 text-sm">Accede al puente de conexión para actualizar artes visuales y flyers del centro infantil.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CentroDeDisenoView;